import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {GlobalService} from '../../api/services/global/global.service';
import {GapLeadsService} from '../../api/services/gap-leads/gap-leads.service';
import {RegisterNewLeadRequest} from '../../api/models/register-new-lead-request';
import {UpdateLeadRequest} from '../../api/models/update-lead-request';

declare let jQuery: any;
declare let jcf: any;

@Component({
  selector: 'app-display-quote',
  templateUrl: './display-quote.component.html',
  styleUrls: ['./display-quote.component.css']
})
export class DisplayQuoteComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  pdfUrl: any;
  downloadUrl: any;
  success: boolean;
  registerSuccess: boolean;
  loading: boolean;
  callMeBackClicked = false;
  pdfBlob: any;

  constructor(private gapLeadsService: GapLeadsService,
              private globalService: GlobalService, private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.globalService.scrollToTop();
    this.blockUI.start();

    if (this.globalService.quotePdfResponse && this.globalService.quotePdfResponse.content) {
      const base64Content = this.globalService.quotePdfResponse.content;
      this.pdfBlob = this.base64ToBlob(base64Content);

      window.URL = window.URL || (window as any).webkitURL;
      this.downloadUrl = window.URL.createObjectURL(this.pdfBlob);
      this.pdfUrl = this.downloadUrl;

      this.transform(this.pdfUrl);
      this.reloadJcf();
      this.blockUI.stop();
    }
    this.updateLead();
  }

  base64ToBlob(base64Content: string) {
    const byteCharacters = atob(base64Content);
    const byteArrays = [];
    const sliceSize = 512;

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: 'application/pdf' })
  }

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  download() {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(this.pdfBlob, 'Discovery Gap - ' + this.globalService.quoteRef + '.pdf');
    } else {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = this.downloadUrl;
      a.download = 'Discovery Gap - ' + this.globalService.quoteRef + '.pdf';
      a.target = '_blank';
      a.click();
      window.URL.revokeObjectURL(this.downloadUrl);
      a.remove();
    }
  }

  reloadJcf() {
    jQuery(function () {
      jcf.replaceAll();
    });
  }

  public registerFlexLead() {
    const request: RegisterNewLeadRequest = {
      quoteId: this.globalService.quoteRef
    };
    this.loading = true;
    this.callMeBackClicked = true;
    this.gapLeadsService.registerLead(request).subscribe(response => {
      if (response != null && response.referenceNumber != null) {
        this.registerSuccess = true;
      } else {
        this.registerSuccess = false;
      }
    }, error1 => {
      this.registerSuccess = false;
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  private updateLead() {
    setTimeout(() => {
      const request: UpdateLeadRequest = {
        quoteRef: this.globalService.quoteRef,
        leadId: this.globalService.gapQuoteDetailsResponse.QuoteDetails[0].leadID.toString(),
        callMeBackClicked: this.callMeBackClicked
      };
      this.gapLeadsService.updateLead(request)
        .subscribe(response => {
          if (response.successIndicator === 1) {
            this.success = true;
          }
        });
    }, 60000);
  }
}
